<template>
  <div>
    <v-text-field
      v-validate="validator"
      outlined
      :value="value"
      label="Ponto de Referencia"
      class="input input-ponto-referencia"
      :error-messages="errors.first(field)"
      :name="field"
      v-bind="config"
      @input="$emit('input', $event)"
    />
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    value: String,
    field: String,
    config: Object,
    validator: Object
  }
}
</script>

<style></style>
